// src/App.tsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import TextBehind from './pages/TextBehind';
import Navbar from './components/layouts/Navbar';
import React from 'react';
import BlogPage from './pages/BlogPage';
import PrivacyPolicy from './pages/Privacypolicy';
import TermsAndConditions from './pages/TermsAndConditions';

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/text-behind-image" element={<TextBehind />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/terms" element={<TermsAndConditions/>} />
      </Routes>
    </Router>
  );
}
